import { AgxBadge } from '@urbanx/agx.ui-components2';
import { getDueDateBadgeState } from 'utils/tasks';

interface TaskDueDateBadgeProps {
  dueDate: Date | string;
  isCompleted: boolean;
  completedDate?: Date | string;
  missingDateText?: string;
}

const TaskDueDateBadge = ({
  dueDate,
  isCompleted,
  completedDate,
  missingDateText,
}: TaskDueDateBadgeProps) => {
  const dueDateValue = dueDate instanceof Date ? dueDate.toISOString() : dueDate;
  const badge = getDueDateBadgeState(dueDateValue, isCompleted, completedDate, missingDateText);

  if (badge.type === 'highlighted') {
    return (
      <AgxBadge
        type="highlighted"
        colour={badge.color}
        size="md"
        text={badge.text}
        highlightText={badge.highlightText}
      />
    );
  }

  return <AgxBadge type="colourfill" colour={badge.color} size="md" text={badge.text} />;
};

export default TaskDueDateBadge;
